export function LineActant ({ actant })  {
  return <span className="line__actant">
    <span className="label">{ actant }</span>
  </span>
}

export default LineActant;